export const LayoutCalculationUtils = {
  methods: {
    checkMediaScreenWidth () {
      const mediaQuery = window.matchMedia('(max-width: 840px)')
      return mediaQuery.matches
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/LayoutCalculation.js